import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";
export const fetchFilterData = async (filters) => {
  try {
    const response = await axios.get(
      `${Config.apiServerUrl}/save_filter/get?account_id=${filters?.account_id}&location_id=${filters?.location_id}&user_id=${filters?.user_id}&filter_type=${filters?.filter_type}`, {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const filterSave = async (saveData) => {
  try {
    const response = await axios.post(
      `${Config.apiServerUrl}/save_filter/create`, saveData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteFilterHistory = async (account_id, location_id, user_id, filter_id) => {
  try {
    const response = await axios.delete(`${Config.apiServerUrl}/save_filter/delete?account_id=${account_id}&location_id=${location_id}&user_id=${user_id}&filter_id=${filter_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {}
};